import { getSessionToken } from '@tiendanube/nexo';
import nexo from 'App/nexoClient';
import axios, { AxiosResponse } from 'axios';
import { transformToCamel } from 'commons/utils';
import {
  dataDogLogger,
  DataDogLoggerActionTypes,
} from 'commons/utils/dataDogLogger';

function logFailedRequest(error: unknown) {
  if (axios.isAxiosError(error)) {
    dataDogLogger.generate({
      actionMessage: 'Request failed',
      actionOwner: 'Axios',
      actionType: DataDogLoggerActionTypes.Error,
      error,
      actionData: error.response?.config?.data ?? {},
    });
  } else {
    dataDogLogger.generate({
      actionMessage: 'Request failed',
      actionOwner: 'Axios',
      actionType: DataDogLoggerActionTypes.Error,
      error,
      actionData: {},
    });
  }
}

function transformResponse(response: AxiosResponse<unknown>) {
  if (!response || !response.data) return response;

  let transformedResponse = {
    ...response,
  };

  try {
    transformedResponse = {
      ...transformedResponse,
      data: transformToCamel(response.data),
    };
  } catch (error: unknown) {
    dataDogLogger.generate({
      actionMessage: 'Conversion failed',
      actionOwner: 'Axios',
      actionType: DataDogLoggerActionTypes.Error,
      error,
      actionData: {
        response,
      },
    });
  }

  return transformedResponse;
}

function transformRejectedResponse(error: unknown) {
  logFailedRequest(error);
  if (axios.isAxiosError(error) && error.response)
    error.response = transformResponse(error.response);
  throw error;
}

export function createApiClient(baseURL: string) {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(async (request) => {
    const token = await getSessionToken(nexo);
    if (token) {
      request.headers.set({
        ...request.headers,
        Authorization: `Bearer ${token}`,
      });
    }
    return request;
  });

  instance.interceptors.response.use(
    transformResponse,
    transformRejectedResponse,
  );

  return instance;
}
